import { Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export default class AngularBroadcastHelperService {
	
	private eventBus: Subject<any>;
	
	constructor() {
		this.eventBus = new Subject<any>();
	}
	
	rootBroadcast(eventName, arg1?, arg2?) {
		this.eventBus.next({key: eventName, data1: arg1, data2: arg2});
	}
	
	rootEmit(eventName, arg1?, arg2?) {
		this.eventBus.next({key: eventName, data1: arg1, data2: arg2});
	}
	
	onRootEvent(eventName, listenerFn): Subscription {
		return this.eventBus.asObservable()
			.pipe(filter(event => event.key === eventName))
			.subscribe(event => listenerFn(event.key, event.data1, event.data2));
	}
	
	onEvent(scopeOwner, eventName, listenerFn): Subscription {
		return this.eventBus.asObservable()
			.pipe(filter(event => event.key === eventName))
			.subscribe(event => listenerFn(event.key, event.data1, event.data2));
	}
	
}